module.exports = __webpack_public_path__ + "static/img/homeOneTable.d2ff530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageOne/homeOneTable.png
// module id = brJZ
// module chunks = 0